import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared/shared.module';
import { ManagerComponentsModule } from '../../components/manager-components.module';
import { AccountSettingsComponent } from './account-settings.component';

@NgModule({
	imports: [SharedModule, ManagerComponentsModule],
	exports: [],
	declarations: [AccountSettingsComponent],
	providers: []
})
export class AccountSettingsModule {}
